import BaseClass from "../BaseClass";


export default class ValueSelector extends BaseClass {
    constructor(element) {
        super(element);
        this.$textInput = null;
        this.$inputMirror = null;
        this.$radios = null;
        this.radioListener = null;
        this.textListener = null;
        this.minValue = 0;
        this.maxValue = 0;
        this.$daysValueHolder = null;
        this.$daysTxtHolder = null;
        this.$allowDecimals = false;
        this.focusListener = null;
        this.blurListener = null;

        this.init();
    }

    init() {
        let mySelf = this;
        this.$textInput = this.$element.find('[data-type="textinput"]');
        this.$inputMirror = this.$element.find('[data-type="inputmirror"]');
        this.$radios = this.$element.find('[type="radio"]');

        let $daysValueHolder = this.$element.find('[data-type="daysvalue"]');
        let $daysTxtHolder = this.$element.find('[data-type="daystxt"]');
        let $allowDecimals = this.$element.data('allowdecimals');

        if ($daysValueHolder != undefined) {
            this.$daysValueHolder = $daysValueHolder;
        }
        if ($daysTxtHolder != undefined) {
            this.$daysTxtHolder = $daysTxtHolder;
        }
        if ($allowDecimals != undefined) {
            this.$allowDecimals = $allowDecimals;
        }
        this.minValue = parseInt(this.$textInput.attr('min'));
        this.maxValue = parseInt(this.$textInput.attr('max'));

        this.radioListener = function (event) {
            let value = $(this).val();
            if (value > mySelf.minValue) {
                mySelf.$textInput.val(value);
                mySelf.setDaysValues(value);
            } else {
                mySelf.$textInput.val("");
                mySelf.setDaysValues(0);
            }
        };

        this.textListener = function () {
            let stringValue = mySelf.$textInput.val();

            if (this.$allowDecimals) {
                stringValue = stringValue.replace(/[^0-9.,]/g, "");
                stringValue = stringValue.replace(",", ".");
                stringValue = stringValue.replace(/\.{2,}/g, ".");
                stringValue = parseFloat(stringValue);
            } else {
                stringValue = stringValue.replace(/\D/g, "");
                stringValue = parseInt(stringValue, 10);
            }

            if (stringValue > mySelf.minValue) {
                if (stringValue > mySelf.maxValue) {
                    stringValue = mySelf.maxValue;
                }
                mySelf.$textInput.val(stringValue);
                mySelf.setDaysValues(stringValue);
            } else {
                mySelf.setDaysValues(0);
                mySelf.$textInput.val("");
            }

        };

        this.focusListener = function (event) {
            mySelf.$textInput.addClass("z-3");
            mySelf.$textInput.removeClass("z-2");

            mySelf.$inputMirror.addClass("z-2");
            mySelf.$inputMirror.removeClass("z-3");
        };

        this.blurListener = function (event) {
            mySelf.$inputMirror.addClass("z-3");
            mySelf.$inputMirror.removeClass("z-2");

            mySelf.$textInput.addClass("z-2");
            mySelf.$textInput.removeClass("z-3");
        };

        this.$radios.on("click", this.radioListener);
        this.$textInput.on("keyup", this.textListener);
        this.$inputMirror.on("click", this.focusListener);
        this.$textInput.on("focus", this.focusListener);
        this.$textInput.on("blur", this.blurListener);

        this.textListener();
    }

    setDaysValues($days) {
        if ($days > 0) {
            if (this.$daysValueHolder != null) {
                this.$daysValueHolder.html($days);
            }
            if (this.$daysTxtHolder != null) {
                if ($days == 1) {
                    this.$daysTxtHolder.html('  ' + this.$daysTxtHolder.attr('data-type-txt-one'));
                } else {
                    this.$daysTxtHolder.html('  ' + this.$daysTxtHolder.attr('data-type-txt-more'));
                }
            }
        } else {
            this.$daysValueHolder.html("");
            this.$daysTxtHolder.html("");
        }
    }
}